<template>
  <v-data-iterator
    :items="items"
    :server-items-length="(!isNaN(parseFloat(serverItemsLength)) && isFinite(serverItemsLength)) ? parseInt(serverItemsLength,10) : serverItemsLength"
    :options.sync="options"
    hide-default-footer
    :disable-filtering="true"
    class="v-data-iterator--custom"
    ref="v-data-iterator"
    v-bind="attributesDataIterator"
    v-resize="onResize"
  >
    <template v-slot:default="props">
      <transition
        name="slide"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut animate-hide"
        mode="out-in"
      >
        <v-row dense>
          <v-col
            v-for="(item, i) in props.items"
            :key="i"
            v-on:dblclick="edit(item[keyValue])"
            cols="12"
            :lg="handleOffsetWidth"
            :md="handleOffsetWidth"
            :sm="handleOffsetWidth"
            :xs="handleOffsetWidth"
            :xl="handleOffsetWidth"
          >
            <v-card class="v-data-iterator--custom__content" tile>
              <v-icon
                v-if="attributesDataIterator.dataIteratorComponents.length > 1"
                @click="handleToggleNav(item)"
                :class="['toggle-nav', toggleNav.includes(item) ? 'close' : '']"
                >{{ toggleNav.includes(item) ? 'close' : 'keyboard_arrow_down' }}</v-icon
              >

              <v-menu
                v-if="actions.length > 0"
                offset-y
                :nudge-bottom="10"
                origin="center center"
                transition="scroll-y-transition"
              >
                <template v-slot:activator="{ on: menu }">
                  <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on: tooltip, attrs }">
                      <v-btn
                        data-has-tooltip="true"
                        data-tooltip="Visualizar açoes"
                        class="btn-action-iterator"
                        small
                        icon
                        v-bind="attrs"
                        v-on="{ ...menu, ...tooltip }"
                      >
                        <v-icon size="22">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar açoes</span>
                  </v-tooltip>
                </template>

                <v-list dense class="p-0">
                  <v-list-item
                    v-for="(action, i) in actions"
                    :key="i"
                    @click="executeAction(action, 'list', item)"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon v-text="action.attributesIcon.icon" v-bind="action.attributesIcon"></v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-subtitle small v-text="action.tooltip"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>

              <div :class="['v-data-iterator--custom__nav ', toggleNav.includes(item) && 'active']">
                <template v-for="el in attributesDataIterator.dataIteratorComponents">
                  <v-tooltip bottom color="primary" :key="el.id">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        :data-has-tooltip="el.label ? 'true' : 'false'"
                        :data-tooltip="el.label"
                        v-on="on"
                        v-bind="attrs"
                        small
                        outlined
                        fab
                        color="white"
                        @click="handleToggleCurrentComponent(el.component, item)"
                      >
                        <v-icon>{{ el.icon }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ el.label }}</span>
                  </v-tooltip>
                </template>
              </div>

              <div class="v-data-iterator--custom__card pa-0">
                <component
                  v-if="toggleComponent[`'${item[keyValue]}'`] || !!defaultComponent"
                  :is="
                    toggleComponent[`'${item[keyValue]}'`]
                      ? toggleComponent[`'${item[keyValue]}'`].component.name
                      : defaultComponent.component.name
                  "
                  v-bind="
                    toggleComponent[`'${item[keyValue]}'`]
                      ? toggleComponent[`'${item[keyValue]}'`].component.attributes
                      : defaultComponent.component.attributes
                  "
                  :model="item"
                  :headers="headers"
                  :attributes="defaultComponent.component.attributes"
                />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </transition>
    </template>

    <template v-if="showTableFooter" v-slot:footer="{ pagination }">
        <v-data-footer
          class="footerTable"
          :showFirstLastPage="true"
          :pagination="pagination"
          :options.sync="options"
          :items-per-page-options="itemsPerPageOptions"
        ></v-data-footer>
      </template>
  </v-data-iterator>
</template>

<script>
import Swal from 'sweetalert2';
import store from '@/store';
import dataTableMixin from '@/mixins/data-table-mixin';

export default {
  mixins: [dataTableMixin],

  props: {
    page: { type: String },
    items: { type: Array, default: () => [] },
    schema: { type: Object, default: () => ({}) },
    toggleDefaultCard: { type: Object, default: undefined },
    editMode: { type: String }
  },

  data: () => ({
    toggleNav: new Array(),
    toggleComponent: new Array(),
    defaultComponent: undefined,
    offsetWidth: window.innerWidth,
    slots: ['footer']
  }),

  mounted() {
    let defaultComponent = undefined;

    this.attributesDataIterator.dataIteratorComponents.forEach(item => {
      if (defaultComponent !== undefined) return;

      if ('default' in item && item.default === true) {
        defaultComponent = item;

        return;
      }
    });

    this.defaultComponent = defaultComponent;

    this.options.itemsPerPage =
      'itemsPerPage' in this.attributesDataIterator
        ? this.attributesDataIterator.itemsPerPage
        : this.itemsPerPageOptions[0].value;

  },

  computed: {
     showTableFooter(){
      return (this.attributesDataIterator || {}).itemsPerPage !== -1
    },

    showFirstLastPage() {
      return this.schema.attributes.attributesDataIterator.showFirstLastPage;
    },
    firstPageTable() {
      return this.schema.attributes.attributesDataIterator.firstIcon;
    },
    lastPageTable() {
      return this.schema.attributes.attributesDataIterator.lastIcon;
    },

    attributesDataIterator() {
      return this.schema.attributes.attributesDataIterator;
    },

    actions() {
      return this.schema.recordActionsModel || [];
    },

    headers() {
      return this.schema.headers;
    },

    keyValue() {
      return this.attributesDataIterator.keyValue;
    },

    breakpoints() {
      return this.attributesDataIterator.breakpoints;
    },

    itemsPerPageOptions() {
      return 'itemsPerPageOptions' in this.attributesDataIterator
        ? this.attributesDataIterator.itemsPerPageOptions
        : [
            {
              text: '4',
              value: 4
            },
            {
              text: '8',
              value: 8
            },
            {
              text: '16',
              value: 16
            },
            {
              text: '64',
              value: 64
            },
            {
              text: '128',
              value: 128
            },
            {
              text: 'Todos',
              value: -1
            }
          ];
    },

    serverItemsLength() {
      const totalRows = (this.items[0]?.total_rows || this.items[0]?.totalRows);

      if (this.items.length && totalRows) {
        return totalRows;
      }
      return -1;
    },

    handleOffsetWidth() {
      if (this.offsetWidth < 600) return this.breakpoints.xs;

      if (this.offsetWidth > 600 && this.offsetWidth < 960) return this.breakpoints.sm;

      if (this.offsetWidth >= 960 && this.offsetWidth < 1264) return this.breakpoints.md;

      if (this.offsetWidth >= 1264 && this.offsetWidth < 1904) return this.breakpoints.lg;

      if (this.offsetWidth >= 1904) return this.breakpoints.xl;
    }
  },

  methods: {

    edit(id) {
      const keyValue = this.keyValue;

      const item = this.items.filter(item => item[keyValue] === id);

      this.$emit('edit-item', { item: item[0], mode: this.attributesDataIterator.editMode, origin: 'card' });
    },

    executeAction(action, origin, model) {
      if (action.confirmMessage) {
        this.confirmDialog(action, origin, model);

        return;
      }

      this.action(action, origin, model);
    },

    async action(action, origin, model) {
      store.dispatch('page/executeAction', {
        page: this.page,
        mode: this.attributesDataIterator.editMode,
        origin,
        action,
        model
      });
    },

    confirmDialog(action, origin, model) {
      const {
        title,
        text,
        html,
        icon,
        showCancelButton,
        confirmButtonText,
        cancelButtonText,
        reverseButtons,
        confirmButtonClass,
        cancelButtonClass
      } = action.confirmMessage;

      let defaultClassConfirm = confirmButtonClass || 'primary';
      let defaultClassCancel = cancelButtonClass || 'error';

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: `v-btn v-size--default ${defaultClassConfirm}`,
          cancelButton: `v-btn v-size--default error ${defaultClassCancel}`
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title,
          text,
          html,
          icon,
          showCancelButton,
          confirmButtonText,
          cancelButtonText,
          reverseButtons
        })
        .then(result => {
          if (result.value) this.action(action, origin, model);
        });
    },

    handleToggleNav(item) {
      if (this.toggleNav.includes(item)) {
        let index = this.toggleNav.indexOf(item);

        this.toggleNav.splice(index, 1);

        return;
      }

      this.toggleNav.push(item);
    },

    handleToggleCurrentComponent(component, item) {
      if (this.toggleNav.includes(item)) {
        let index = this.toggleNav.indexOf(item);

        this.toggleNav.splice(index, 1);
      }

      if ('name' in component) {
        this.toggleComponent[`'${item[this.keyValue]}'`] = { component, item };

        return;
      }

      delete this.toggleComponent[`'${item[this.keyValue]}'`];
    },

    onResize() {
      this.offsetWidth = this.$refs['v-data-iterator'].$el.offsetWidth;
    }
  },

  watch: {
    toggleDefaultCard(newValue) {
      this.toggleComponent = [];

      this.defaultComponent = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  overflow: visible;
  contain: initial;
  max-width: 90%;
  border-bottom: 3px solid var(--v-primary-base);
  &:after {
    bottom: 100%;
    left: 3%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(136, 183, 213, 0);
    border-width: 8px;
  }
}

.theme--dark {
  .v-menu__content {
    &:after {
      border-bottom-color: #424242;
    }
  }
}

.theme--light {
  .v-menu__content {
    &:after {
      border-bottom-color: #ffffff;
    }
  }
}

</style>
